module.exports = __webpack_public_path__ + "40ecdd671a35fb1a26d887e242de08f4.png";